import { actionId } from '@/annotations'
import type { NavGroup } from '@/routes/navigation'
import { LauncherCard } from '@/components/LauncherCard'

/**
 * The six group landings (`design/27-ui-surface-and-navigation.md` §27.1 property 1: "generated
 * from the home index, never hand-maintained" — one description of each screen, rendered in two
 * places). **Rebuilt W174** alongside `VHome` to the same real `launcher-card` grid, from the
 * same bare bordered `<li>` text-link shape.
 */
export function GroupLanding({ group, onNavigate }: { group: NavGroup; onNavigate: (routeId: string) => void }) {
  return (
    <div>
      <h1 className="m-0 mb-8 text-section font-semibold">{group.title}</h1>
      <div className="grid gap-8" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(330px, 1fr))' }}>
        {group.leaves.map((leaf) => (
          <LauncherCard
            key={leaf.routeId}
            variant={group.accent}
            icon={leaf.icon}
            title={leaf.title}
            description={leaf.summary}
            actionId={actionId(`nav.${leaf.unitId}`)}
            onClick={() => onNavigate(leaf.routeId)}
          />
        ))}
      </div>
    </div>
  )
}
